import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    :root {
        --red: #FF4949;
        --black: #2E2E2E;
        --yellow: #ffc600;
        --white: #fff;
        --grey: #a7b1c2;
        --bg: #111827;
        --font: #f4f7fb;
        --navy-panel: #07172f;
        --navy-panel-deep: #031025;
        --main-column: #1f2937;
        --main-column-dark: #171f2c;
        --surface: rgba(25, 33, 47, 0.92);
        --surface-elevated: rgba(33, 43, 60, 0.9);
        --surface-border: rgba(149, 179, 214, 0.22);
        --text-primary: #f8fbff;
        --text-secondary: rgba(247, 250, 255, 0.92);
        --text-muted: rgba(226, 235, 247, 0.68);
        --accent-blue: #3da6ff;
        --accent-teal: #26d6b2;
        --accent-ice: #bde9ff;
        --text-color-light: #222;
        --text-color-dark: var(--text-primary);
        color-scheme: light dark;
    }
    
    html {
        background-attachment: fixed;
        font-size: 18px;
        background:
            radial-gradient(circle at 20% 10%, rgba(61, 166, 255, 0.18), transparent 26rem),
            radial-gradient(circle at 82% 16%, rgba(189, 233, 255, 0.12), transparent 24rem),
            linear-gradient(90deg, var(--navy-panel-deep) 0%, var(--navy-panel) 14%, var(--main-column-dark) 30%, var(--main-column) 50%, var(--main-column-dark) 70%, var(--navy-panel) 86%, var(--navy-panel-deep) 100%);
        background-color: var(--bg);
        scrollbar-width: thin;
        scrollbar-color: var(--accent-blue) var(--navy-panel-deep);
    }

    body {
        color: var(--text-primary);
        min-height: 100vh;
        background:
            linear-gradient(180deg, rgba(255, 255, 255, 0.035), transparent 22rem),
            radial-gradient(circle at 50% 3rem, rgba(38, 214, 178, 0.08), transparent 30rem);
    }

    body::before {
        content: "";
        position: fixed;
        inset: 0;
        pointer-events: none;
        z-index: -1;
        background:
            linear-gradient(90deg, rgba(7, 23, 47, 0.86), transparent 17%, transparent 83%, rgba(7, 23, 47, 0.86)),
            linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.045) 32%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.045) 68%, transparent 100%);
        box-shadow: inset 22vw 0 28vw rgba(3, 16, 37, 0.62), inset -22vw 0 28vw rgba(3, 16, 37, 0.62);
    }

    fieldset {
        border-color: rgba(0, 0, 0, 0.1);
        border-width: 1px;
    }

    .gatsby-image-wrapper img[src*=base64\\,] {
        image-rendering: -moz-crisp-edges;
        image-rendering: pixelated;
    }

    /* Scrollbar Styles */
    body::-webkit-scrollbar {
        width: 12px;
    }
    
    body::-webkit-scrollbar-track {
        background: var(--navy-panel-deep);
    }

    body::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, var(--accent-blue), var(--accent-teal));
        border-radius: 6px;
        border: 3px solid var(--navy-panel-deep);
    }

    hr {
        border: 0;
        height: 8px;
        background-size: 1500px;
    }

    img {
        max-width: 100%;
    }

    .logo {
        color: rgba(244, 248, 253, 0.82);
    }

    .logo span {
        color: var(--text-primary);
    }

    .portfolio-header {
        background:
            radial-gradient(circle at 28% 0%, rgba(61, 166, 255, 0.16), transparent 22rem),
            radial-gradient(circle at 78% 0%, rgba(38, 214, 178, 0.1), transparent 20rem),
            linear-gradient(110deg, rgba(7, 23, 47, 0.98), rgba(19, 33, 53, 0.98) 48%, rgba(8, 28, 52, 0.98)) !important;
        border-bottom: 1px solid rgba(143, 216, 255, 0.16);
        box-shadow:
            0 18px 48px rgba(3, 16, 37, 0.32),
            inset 0 1px 0 rgba(255, 255, 255, 0.06);
        overflow: hidden;
        position: relative;
        z-index: 50;
    }

    .portfolio-header::before,
    .portfolio-header::after {
        content: "";
        pointer-events: none;
        position: absolute;
    }

    .portfolio-header::before {
        animation: portfolio-header-sheen 14s ease-in-out infinite alternate;
        background:
            linear-gradient(105deg, transparent 16%, rgba(189, 233, 255, 0.08) 38%, transparent 58%),
            radial-gradient(circle at 50% 0%, rgba(61, 166, 255, 0.13), transparent 18rem);
        inset: 0;
        opacity: 0.9;
        transform: translateX(-10%);
    }

    .portfolio-header::after {
        background: linear-gradient(90deg, transparent, rgba(61, 166, 255, 0.55), rgba(38, 214, 178, 0.42), transparent);
        bottom: 0;
        height: 1px;
        left: 12%;
        right: 12%;
    }

    .portfolio-header > div {
        position: relative;
        z-index: 1;
    }

    .portfolio-header .logo {
        text-shadow: 0 0 22px rgba(189, 233, 255, 0.16);
    }

    .portfolio-header a {
        transition: color 0.2s ease, text-shadow 0.2s ease;
    }

    .portfolio-header a:hover {
        text-shadow: 0 0 18px rgba(143, 216, 255, 0.22);
    }

    .navbar,
    nav {
        color: var(--text-secondary);
    }

    nav a,
    nav button {
        color: rgba(248, 251, 255, 0.9);
    }

    nav a:hover,
    nav button:hover {
        color: var(--text-primary);
    }

    @keyframes portfolio-header-sheen {
        0% {
            opacity: 0.68;
            transform: translateX(-12%);
        }

        100% {
            opacity: 1;
            transform: translateX(12%);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .portfolio-header::before {
            animation: none;
            transform: none;
        }
    }

    @media (prefers-color-scheme: light) {
        :root {
            --grey: #53657a;
            --bg: #dceeff;
            --font: #142235;
            --navy-panel: #cfe7fa;
            --navy-panel-deep: #b8d8f2;
            --main-column: #f9fcff;
            --main-column-dark: #eaf4fc;
            --surface: rgba(255, 255, 255, 0.88);
            --surface-elevated: rgba(255, 255, 255, 0.96);
            --surface-border: rgba(49, 105, 149, 0.18);
            --text-primary: #102033;
            --text-secondary: rgba(28, 43, 62, 0.86);
            --text-muted: rgba(78, 95, 118, 0.74);
            --accent-blue: #2386c8;
            --accent-teal: #0d9f8f;
            --accent-ice: #d9f2ff;
            --text-color-dark: var(--text-primary);
        }

        html {
            background:
                radial-gradient(circle at 18% 7%, rgba(74, 161, 221, 0.18), transparent 27rem),
                radial-gradient(circle at 82% 10%, rgba(13, 159, 143, 0.12), transparent 24rem),
                linear-gradient(90deg, #c9e5f8 0%, #dceeff 16%, #f9fcff 32%, #ffffff 50%, #f9fcff 68%, #dceeff 84%, #c9e5f8 100%);
            background-color: var(--bg);
            scrollbar-color: var(--accent-blue) #eaf4fc;
        }

        body {
            background:
                linear-gradient(180deg, rgba(255, 255, 255, 0.6), transparent 24rem),
                radial-gradient(circle at 50% 4rem, rgba(35, 134, 200, 0.08), transparent 32rem);
            color: var(--text-primary);
        }

        body::before {
            background:
                linear-gradient(90deg, rgba(184, 216, 242, 0.58), transparent 18%, transparent 82%, rgba(184, 216, 242, 0.58)),
                linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 32%, rgba(255, 255, 255, 0.82) 50%, rgba(255, 255, 255, 0.5) 68%, transparent 100%);
            box-shadow: inset 18vw 0 28vw rgba(167, 205, 235, 0.34), inset -18vw 0 28vw rgba(167, 205, 235, 0.34);
        }

        body::-webkit-scrollbar-track {
            background: #eaf4fc;
        }

        body::-webkit-scrollbar-thumb {
            border-color: #eaf4fc;
        }

        .logo {
            color: rgba(28, 43, 62, 0.74);
        }

        .logo span {
            color: #102033;
        }

        .portfolio-header {
            background:
                radial-gradient(circle at 28% 0%, rgba(35, 134, 200, 0.18), transparent 22rem),
                radial-gradient(circle at 78% 0%, rgba(13, 159, 143, 0.12), transparent 20rem),
                linear-gradient(110deg, rgba(236, 247, 255, 0.96), rgba(255, 255, 255, 0.98) 48%, rgba(229, 244, 255, 0.96)) !important;
            border-bottom-color: rgba(49, 105, 149, 0.16);
            box-shadow:
                0 14px 38px rgba(63, 119, 163, 0.16),
                inset 0 1px 0 rgba(255, 255, 255, 0.92);
        }

        .portfolio-header::before {
            background:
                linear-gradient(105deg, transparent 16%, rgba(35, 134, 200, 0.08) 38%, transparent 58%),
                radial-gradient(circle at 50% 0%, rgba(13, 159, 143, 0.08), transparent 18rem);
        }

        .portfolio-header::after {
            background: linear-gradient(90deg, transparent, rgba(35, 134, 200, 0.34), rgba(13, 159, 143, 0.26), transparent);
        }

        .portfolio-header .logo {
            text-shadow: none;
        }

        nav a,
        nav button {
            color: rgba(36, 52, 72, 0.82);
        }

        nav a:hover,
        nav button:hover {
            color: #0f253a;
        }

        .code-accordion {
            background: linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(232, 244, 253, 0.96)) !important;
            border-color: rgba(49, 105, 149, 0.18) !important;
            box-shadow:
                0 18px 46px rgba(63, 119, 163, 0.16),
                inset 0 1px 0 rgba(255, 255, 255, 0.88) !important;
        }

        .code-accordion__button:hover {
            background: rgba(35, 134, 200, 0.06) !important;
        }

        .code-accordion__eyebrow {
            color: #0d9f8f !important;
        }

        .code-accordion__title {
            color: #102033 !important;
        }

        .code-accordion__hint {
            color: rgba(78, 95, 118, 0.82) !important;
        }

        .code-accordion__icon {
            background: rgba(35, 134, 200, 0.08) !important;
            border-color: rgba(35, 134, 200, 0.2) !important;
            color: #166fa8 !important;
            box-shadow: 0 0 18px rgba(35, 134, 200, 0.12) !important;
        }
    }

    .gif-loader {
        align-items: center;
        background: linear-gradient(135deg, light-dark(#f4f4f7, #2c2c34), light-dark(#e7e7ec, #22222a));
        border: 1px solid light-dark(#dedee6, #3c3c46);
        border-radius: 6px;
        box-sizing: border-box;
        color: light-dark(#555, #d8d8df);
        display: flex;
        justify-content: center;
        margin: 12px auto 18px;
        min-height: clamp(180px, 34vw, 420px);
        overflow: hidden;
        position: relative;
        width: 100%;
    }

    .gif-loader__indicator {
        animation: gif-loader-spin 0.8s linear infinite;
        aspect-ratio: 1 / 1;
        border: 3px solid light-dark(rgba(46, 46, 46, 0.18), rgba(255, 255, 255, 0.22));
        border-top-color: var(--red);
        border-radius: 50%;
        box-sizing: border-box;
        display: block;
        height: 38px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 38px;
    }

    .gif-loader__image {
        display: block;
        height: auto;
        margin: 0 !important;
        max-width: 100%;
        opacity: 0;
        width: 100%;
    }

    .gif-loader--loaded {
        align-items: center;
        background: transparent;
        border: 0;
        display: flex;
        justify-content: center;
        min-height: 0;
        padding: 3px;
        width: fit-content;
    }

    .gif-loader--loaded .gif-loader__image {
        border-radius: 4px;
        box-shadow: none !important;
        opacity: 1;
    }

    .gif-loader--loaded .gif-loader__indicator {
        display: none;
    }

    @keyframes gif-loader-spin {
        to {
            transform: translate(-50%, -50%) rotate(360deg);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .gif-loader__indicator {
            animation: none;
        }
    }
    
    h1 {
        font-weight: bold;
        font-size: 25px;
    }
    
`;

export default GlobalStyles;
